<p>
  {{ "centralizeDataOwnershipDesc" | i18n }}
  <a
    bitLink
    href="https://bitwarden.com/resources/credential-lifecycle-management/"
    target="_blank"
    endIcon="bwi-external-link"
  >
    {{ "centralizeDataOwnershipContentAnchor" | i18n }}
  </a>
</p>

<div class="tw-text-left tw-overflow-hidden tw-mb-2">
  <strong>{{ "benefits" | i18n }}:</strong>
  <ul class="tw-pl-7 tw-space-y-2 tw-pt-2">
    <li>
      {{ "centralizeDataOwnershipBenefit1" | i18n }}
    </li>
    <li>
      {{ "centralizeDataOwnershipBenefit2" | i18n }}
    </li>
    <li>
      {{ "centralizeDataOwnershipBenefit3" | i18n }}
    </li>
  </ul>
</div>

<bit-form-control>
  <input class="tw-mt-4" type="checkbox" bitCheckbox [formControl]="enabled" id="enabled" />
  <bit-label>{{ "turnOn" | i18n }}</bit-label>
</bit-form-control>

@if (useMyItems()) {
  <bit-form-control>
    <input
      type="checkbox"
      bitCheckbox
      [formControl]="data.controls.enableIndividualItemsTransfer"
      id="enableIndividualItemsTransfer"
    />
    <bit-label>{{ "promptUsersToMoveItems" | i18n }}</bit-label>
  </bit-form-control>

  @if (enableIndividualItemsTransfer()) {
    <bit-callout type="info">
      {{ "promptUsersToMoveItemsCallout" | i18n }}
      <a
        bitLink
        href="https://bitwarden.com/resources/credential-lifecycle-management/"
        target="_blank"
        endIcon="bwi-external-link"
      >
        {{ "centralizeDataOwnershipWarningLink" | i18n }}
      </a>
    </bit-callout>
  }
}
